export const MENU_ITEM_ID = {
  COOKIES: 'cookies',
}
